import * as firebase from 'firebase'
import {tidyObj} from "../helpers.js"
import { Store } from 'vuex';


export default {
  state: {
    notifications:[],
     
      },
  mutations: {
    addNotification(state,payload){
      state.notifications.push(payload)
    }
  },
  actions: {
   
  },
  getters: {
   
    getNotifications(state){
      return state.notifications
    }
  }
}

